import React, { Component, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout, TextField, TextStyle, Button, Select, ChoiceList, SettingToggle, Checkbox } from '@shopify/polaris';

import { BasicTextField } from '@presentational';
import { fullName } from '@utils';
import { tAttribute } from '@utils';
import TagsInput from 'react-tagsinput';
import axiosRails from '@utils/axios';

import { selectOptionsProp } from 'utils/shapeProps'

const propTypes = {
  users: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired, // currently it is a slightly altered setFieldChange from formik => setFieldValue("seller." + id, value) 
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,

  deliveryTeamOptions: selectOptionsProp.isRequired, // can be empty!
};

const options_credit = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '60', value: '60' },
];

class SellerForm extends Component {
  render() {
    let { handleSubmit, isNested } = this.props;
    if (isNested) {
      return (
        <FormLayout>
          <h2 className="Polaris-DisplayText Polaris-DisplayText--sizeLarge pt30">Seller</h2>
          <hr />
          {this.formContent()}
        </FormLayout>
      )
    } else {
      return (
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <hr />
            {this.formContent()}
            <Button submit>Submit</Button>
          </FormLayout>
        </Form>
      );
    }
  }

  handleChangeNumber = (value, id) => {
    handleChange(Number(value), id);
  }

  // Verify that the textual `vendor` value is valid and not already in use
  searchVendor = async () => {
    try {
      const response = await axiosRails.get('/admin/sellers/search_vendor', {
        params: {
          query: this.props.values.vendor,
          seller_id: this.props.values.id || null
        }
      });
      const { message } = response.data;
      alert(message);
    } catch (error) {
      console.error(error);
      alert("Error de sistema")
    }
  }

  formContent = () => {
    let { users, locations, handleChange, handleSubmit, values, errors, isNested } = this.props;
    let sharedFieldProps = {
      handleChange,
      values,
      errors
    }

    const options_user = users.map(user => {
      return {
        label: fullName(user),
        value: user.id
      }
    });

    console.log("SF", values);

    return (
      <div className="Polaris-FormLayout__Item-child">
        {!isNested ? (
          <Select
            id="user_id"
            name="user_id"
            label="User"
            options={options_user}
            value={values.user_id}
            onChange={this.handleChangeNumber}
            {...sharedFieldProps}
          />
        ) : null}

        <ApuToggle handleToggle={(apu) => handleChange(apu, 'apu')} initialValue={values.apu} />

        <BasicTextField
          name="vendor"
          label={tAttribute("seller", "vendor")}
          {...sharedFieldProps}
          connectedRight={
            <Button primary onClick={this.searchVendor}>Verificar</Button>
          }
        />

        {/* Currently disabled as production only got ONE location */}
        {/* { values.apu &&
          <Select
            id="default_location_id"
            name="default_location_id"
            label={ tAttribute("seller", "default_location_id") }
            options={ this.props.locations }
            value={ values.default_location_id }
            onChange={ handleChange }
            error={ errors.default_location_id }
          />
        } */}

        <BasicTextField
          name="legal_id"
          label={tAttribute("seller", "legal_id")}
          {...sharedFieldProps}
        />

        <BasicTextField
          name="address"
          label={tAttribute("seller", "address")}
          {...sharedFieldProps}
        />

        <BasicTextField
          name="phone_number"
          label={tAttribute("seller", "phone_number")}
          {...sharedFieldProps}
        />

        {!values.apu &&
          <div>
            <label>CCs</label>
            <TagsInput
              value={values.ccs}
              name="ccs"
              onlyUnique
              addKeys={[188, 9, 13]}
              inputProps={{
                className: `react-tagsinput-input`,
                placeholder: I18n.t("form.placeholder.ccs.value"),
              }}
              onChange={(item) => { handleChange(item, 'ccs') }}
            />
          </div>
        }

        <BasicTextField
          name="bank_account_number"
          label={tAttribute("seller", "bank_account_number")}
          {...sharedFieldProps}
        />

        {this.props.deliveryTeamOptions.length > 0 &&
          <Select
            id="delivery_team_id"
            name="delivery_team_id"
            label={tAttribute("seller", "delivery_team_id")}
            options={this.props.deliveryTeamOptions}
            value={values.delivery_team_id && String(values.delivery_team_id)}
            onChange={handleChange}
          />
        }

        <div>
          <Checkbox
            label={tAttribute("seller", "email_report")}
            checked={values.email_report}
            onChange={(value) => handleChange(value, 'email_report')}
          />
        </div>

        <div>
          <Checkbox
            label={tAttribute("seller", "sync_tasks")}
            checked={values.sync_tasks}
            onChange={(value) => handleChange(value, 'sync_tasks')}
            error={errors["seller.sync_tasks"]}
          />
        </div>

        <div>
          <Checkbox
            label={tAttribute("seller", "products_read_only")}
            checked={values.products_read_only}
            onChange={(value) => handleChange(value, 'products_read_only')}
            error={errors["seller.products_read_only"]}
          />
        </div>
      </div>
    );
  }
}

const ApuToggle = (props) => {
  const [active, setActive] = useState(props.initialValue);

  const handleToggle = useCallback(() => {
    setActive((active) => {
      props.handleToggle(!active); // Send new value to parent
      return !active // new local state 
    })
  }, []);

  const contentStatus = active ? 'Deshabilitar' : 'Habilitar';

  return (
    <SettingToggle
      action={{
        content: contentStatus,
        onAction: handleToggle,
      }}
      enabled={active}
    >
      {I18n.t("app.apb.title")}
      <br />
      <TextStyle variation="strong">
        {active ? I18n.t("app.apb.seller_enabled") : I18n.t("app.apb.seller_disabled")}
      </TextStyle>
    </SettingToggle>
  );
}

SellerForm.propTypes = propTypes;

export default SellerForm;
